var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-content',{attrs:{"with_go_back_bar":""}},[_c('template',{slot:"action_bar"},[_c('router-link',{staticClass:"btn btn-success mx-2",attrs:{"to":"/shareholder/create"},domProps:{"textContent":_vm._s(_vm.$t('label.create_shareholder'))}})],1),_c('kt-datatable',_vm._b({ref:"datatable"},'kt-datatable',_vm.datatableProps,false))],2)
}
var staticRenderFns = []

export { render, staticRenderFns }